export default "__VITE_ASSET__1gQ9IQFy__"